module.exports = __webpack_public_path__ + "static/img/logo_250x250.4239196.png";


//////////////////
// WEBPACK FOOTER
// /var/tomcat/.jenkins/workspace/EasyTitle24/easytitle24-2.x-common/img/logo_250x250.png
// module id = lTJ3
// module chunks = 1 2